import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import CurrentParticipantsSection from './CurrentParticipantsSection';
import CommentApi from '../../api/commentApi';
import SkillApi from '../../api/skillApi';
import Question from '../../components/molecules/question/Question';
import Card from '../../components/organisms/Card';
import HeaderArea from '../../components/page-layout/HeaderArea';
import PageHeaderAndMain from '../../components/page-layout/PageHeaderAndMain';
import SectionService from '../../services/sectionService';
import { Breadcrumbs } from '../../types/breadcrumbs';
import CommentData from '../../types/commentData';
import SkillData from '../../types/skillData';
import useUserProfilesWithCompleteSections from '../../utils/hooks/useUserProfilesWithCompleteSections';

import './Statistics.scss';

export default function Statistics() {
  const { skillSlug } = useParams<{ skillSlug: string }>();
  const [skill, setSkill] = useState<SkillData>();
  const [unansweredQuestions, setUnansweredQuestions] = useState<CommentData[]>([]);
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumbs>([
    ['/my-creations', 'My Creations'],
    ['#', 'Loading...'],
    ['#', 'Statistics'],
  ]);
  const [sectionCount, setSectionCount] = useState<number>();

  const currentParticipants = useUserProfilesWithCompleteSections(skill);

  useEffect(() => {
    async function fetchData() {
      const fetchedSkill = await SkillApi.getSkillBySlug(skillSlug!);
      const fetchedComments = await CommentApi.getCommentsByContextId(fetchedSkill.id);
      const fetchedSectionCount = await SectionService.getSectionCountBySkill(fetchedSkill.id);
      // const fetchedReviews = await ReviewService.getModuleReviewsWithUserProfile(fetchedModule.id);

      const fetchedUnansweredQuestions = fetchedComments
        .filter(comment => comment.topLevelCommentId === null) // Filter for top level comments (questions)
        .filter(question => {
          // Filter for questions without replies
          return !fetchedComments.find(comment => comment.topLevelCommentId === question.id);
        });

      setSkill(fetchedSkill);
      setUnansweredQuestions(fetchedUnansweredQuestions);
      setBreadcrumbs([
        ['/my-creations', 'My Creations'],
        [`/skills/${fetchedSkill.slug}`, fetchedSkill.name],
        ['#', `Statistics`],
      ]);
      // setReviews(fetchedReviews);
      setSectionCount(fetchedSectionCount);
    }
    fetchData();
  }, [skillSlug]);

  // const Reviews = reviews.map(review => {
  //   return (
  //     <div key={review.id} className="review mb-8">
  //       <p className="italic">{review.review}</p>
  //       <p>by {review.userProfile.firstName}</p>
  //     </div>
  //   );
  // });

  const Questions = unansweredQuestions.map(question => {
    return (
      <li key={question.id}>
        <Question comment={question} />
      </li>
    );
  });

  return (
    <PageHeaderAndMain className="statistics-page">
      <HeaderArea breadcrumbs={breadcrumbs}>
        <h1 className="strong-heading">{`Statistics — ${skill?.name || '...'}`}</h1>
      </HeaderArea>
      <main>
        <Card className="main-stats-grid p-16 mb-8">
          {currentParticipants && sectionCount !== undefined && (
            <CurrentParticipantsSection currentParticipants={currentParticipants} totalSections={sectionCount} />
          )}
          <div className="">
            <h2 className="text-lg font-medium mb-8">All participants</h2>
            <div className="tba border-radius md" />
          </div>
          <div className="content-section">
            <h2 className="text-lg font-medium mb-8">Unanswered Questions</h2>
            {Questions.length > 0 ? <ul>{Questions}</ul> : <p>There are no unanswered questions</p>}
          </div>
        </Card>
        <Card className="p-16">
          <h2 className="text-lg font-medium mb-8">Reviews</h2>
          <div className="tba border-radius md" />
        </Card>
      </main>
    </PageHeaderAndMain>
  );
}
